"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const DelegatingGridLayout_1 = tslib_1.__importDefault(require("../DelegatingGridLayout"));
const GridConstants_1 = tslib_1.__importDefault(require("../GridConstants"));
class ExpandingGridLayout extends DelegatingGridLayout_1.default {
    constructor(gridConfig) {
        super();
        this.expandedRowTR = null;
        this.multipleExpandedRowsAllowed = false;
        this.numAnimationSteps = 5;
        this.animationStepTime = 2;
        this.animationEnabled = true;
        this.gridConfig = gridConfig;
        this.table = this.gridConfig.getTable();
    }
    setDelegate(delegate) {
        this.delegate = delegate;
    }
    expandOrCollapse(data, domRow, ariaControlId) {
        if (!domRow) {
            domRow = this.data2Tr(data);
        }
        if (data) {
            if (this.isExpanded(data)) {
                this.removeExpandedRow(data, domRow);
                this.expandedRowTR = null;
                return false;
            }
            else {
                this.insertExpandedRow(data, domRow, ariaControlId);
                return true;
            }
        }
        else {
            return false;
        }
    }
    dataChanged() {
        this.rowExpandedMap = null;
        this.delegate.dataChanged(false);
        this.expandExpandedRows();
    }
    setMultipleExpandedRowsAllowed(multipleExpandedRowsAllowed) {
        this.multipleExpandedRowsAllowed = multipleExpandedRowsAllowed;
    }
    isMultipleExpandedRowsAllowed() {
        return this.multipleExpandedRowsAllowed;
    }
    setAnimationEnabled(animationEnabled) {
        this.animationEnabled = animationEnabled;
    }
    isAnimationEnabled() {
        return this.animationEnabled;
    }
    setNumAnimationSteps(numAnimationSteps) {
        this.numAnimationSteps = numAnimationSteps;
    }
    getNumAnimationSteps() {
        return this.numAnimationSteps;
    }
    setAnimationStepsMillis(animationStepsMillis) {
        this.animationStepTime = animationStepsMillis;
    }
    getAnimationStepsMillis() {
        return this.animationStepTime;
    }
    isExpanded(data) {
        return this.rowExpandedMap == null ? false : this.rowExpandedMap.has(data);
    }
    expandExpandedRows() {
        this.expandedRowTR = null;
    }
    getExpanded(data) {
        if (this.rowExpandedMap == null) {
            this.rowExpandedMap = new Map();
        }
        return this.rowExpandedMap.get(data);
    }
    addExpanded(data, widget) {
        if (this.rowExpandedMap == null) {
            this.rowExpandedMap = new Map();
        }
        this.rowExpandedMap.set(data, widget);
    }
    removeExpanded(data) {
        if (this.rowExpandedMap == null) {
            this.rowExpandedMap = new Map();
        }
        this.rowExpandedMap.delete(data);
    }
    insertExpandedRow(data, after, ariaControlId) {
        after.classList.add(GridConstants_1.default.GRID_ROW_EXPANDED);
        const expanderRow = this.table.insertRow(this.getRowForTR(after) + 1);
        const detailRow = expanderRow.rowIndex - 1;
        this.table.setColSpan(detailRow, 0, this.gridConfig.getNumberOfColumns());
        const widget = this.gridConfig.getWidget(data);
        widget.element.classList.add(GridConstants_1.default.GRID_ROW_EXPAND_VIEW);
        widget.element.setAttribute("role", fmko_ts_common_1.ARIARole.REGION);
        if (ariaControlId) {
            widget.element.id = ariaControlId;
        }
        this.table.setWidget(detailRow, 0, widget);
        const widgetHeight = widget.element.getBoundingClientRect().height;
        widget.element.classList.add(GridConstants_1.default.GRID_ROW_EXPAND_EXPANDED_READY);
        this.addExpanded(data, widget);
        this.table.addRowStyle(detailRow, GridConstants_1.default.GRID_ROW_EXPAND_EXPANDED);
        widget.element.style.top = `${-widgetHeight}px`;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        window.getComputedStyle(widget.element).display; // Force reflow, so that the widget animates
        this.toggleExpand(widget.element, widgetHeight);
        if (widgetHeight > 0) {
            setTimeout(() => {
                expanderRow.classList.add(GridConstants_1.default.GRID_ROW_EXPAND_EXPANDED_ANIMATED);
                widget.element.style.height = "auto"; // Make sure height doesn't lock height to initial expanded view
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                window.getComputedStyle(widget.element).display; // Force reflow, so that the widget animates
                if (!fmko_ts_common_1.DOM.isElementFullyVisible(widget.element)) {
                    after.scrollIntoView({
                        behavior: "smooth"
                    });
                }
            }, GridConstants_1.default.EXPANDING_HEIGHT_TRANSITION_TIMING);
        }
        if (!this.multipleExpandedRowsAllowed) {
            if (this.expandedRowTR && this.expandedRowTR.parentElement) {
                this.removeExpandedRow(this.tr2Data(this.expandedRowTR), this.expandedRowTR);
            }
            this.expandedRowTR = after;
        }
    }
    removeExpandedRow(data, domRow) {
        this.doRemoveExpandedRow(data, domRow);
    }
    doRemoveExpandedRow(data, trElement) {
        const detailRow = trElement.nextElementSibling;
        const widget = this.getExpanded(data);
        if (widget) {
            detailRow.classList.remove(GridConstants_1.default.GRID_ROW_EXPAND_EXPANDED_ANIMATED);
            this.toggleExpand(widget.element, 0);
        }
        setTimeout(() => {
            this.table.removeRow(this.getRowForTR(detailRow));
            this.removeExpanded(data);
            trElement.classList.remove(GridConstants_1.default.GRID_ROW_EXPANDED);
        }, GridConstants_1.default.EXPANDING_HEIGHT_TRANSITION_TIMING);
    }
    getRowForTR(tr) {
        return tr.rowIndex - 1;
    }
    toggleExpand(element, height) {
        if (height > 0) {
            element.style.top = "0px";
            element.style.height = `${height}px`;
            element.style.opacity = "1";
        }
        else {
            element.style.height = `${element.getBoundingClientRect().height}px`; // Change height to current height before animating
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            window.getComputedStyle(element).display;
            element.style.height = "0";
            element.style.top = `${-element.getBoundingClientRect().height}px`;
            element.style.opacity = "0";
        }
    }
}
exports.default = ExpandingGridLayout;
//# sourceMappingURL=ExpandingGridLayout.js.map